module.exports = __webpack_public_path__ + "img/aztecLegend.d1d2cd4e.jpeg";